import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { SearchIcon } from '@primer/octicons-react'
import LocPickerDialog from './LocPickerDialog';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const ModelObjAdmin_NewModelObjView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [modelObjAttrs, setModelObjAttrs] = useState({
    modelElemId: '',
    objId: '',
    objType: '',
    location: '',
    locationId: '',
    bimGuid: '',
    bimElementId: ''
  });


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setModelObjAttrs({ ...modelObjAttrs, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!modelObjAttrs.modelElemId || modelObjAttrs.modelElemId.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_model_elem_id"));
    } else if (!modelObjAttrs.objId || modelObjAttrs.objId.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_obj_id"));
    } else if (modelObjAttrs.objId.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_obj_id") + 30);
    } else if (modelObjAttrs.objType.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_obj_type") + 20);
    } else if (!modelObjAttrs.objType || modelObjAttrs.objType.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_obj_type"));
    } else {
      validateObjIdAndType();
    }

    return;
  }

  // Since this is async, need to call this first, and check for duplicate
  function validateObjIdAndType() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("model-obj-mappings?objId=" + modelObjAttrs.objId + "&objType=" + modelObjAttrs.objType);

        resolve(res.data);

        if ((res.status === 200) && res.data.length > 0) {
          // ModelObj id is already defined
          setErrMsg(t("I18N_ERR_Obj_id_and_type_exists"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    if (modelObjAttrs.bimGuid && modelObjAttrs.bimGuid.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_obj_bim_guid") + 50);
    } else if (modelObjAttrs.bimElementId && modelObjAttrs.bimElementId.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_obj_bim_elem_id") + 50);
    } else {
      createNewModelObj();
    }
  }

  const createNewModelObj = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(modelObjAttrs));

    // Note: reqBody.location is actually not used by the API
    if (reqBody.location === '') {
      reqBody.locationId = null;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("model-obj-mappings", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  // Location select dialog stuff

  const [showLocPickerDialog, setShowLocPickerDialog] = useState(false);

  const handleLocPicker = (e) => {
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {

    // Deep copy
    let newAttrs = JSON.parse (JSON.stringify(modelObjAttrs));
    newAttrs.locationId = location.id;
    newAttrs.location   = location.code;

    setModelObjAttrs(newAttrs);

    setShowLocPickerDialog(false);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_ModelObjMapping")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_ModelObjMapping_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Model_elem_id")}: *</Col>
              <Col md={3}>{t("I18N_Obj_id")}: *</Col>
              <Col md={3}>{t("I18N_Obj_type")}: *</Col>
              <Col md={3}>{t("I18N_Location_code")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="modelElemId" value={modelObjAttrs.modelElemId}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="objId" value={modelObjAttrs.objId}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="objType" value={modelObjAttrs.objType}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input readOnly className={classes.admin_pages__field_editable} style={{minWidth: '85%'}} name="location" value={modelObjAttrs.location}
                  onChange={(e) => onAttrsInputChange(e)} />
                <span onClick={handleLocPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <SearchIcon size={14} />
                </span>
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col md={3}>{t("I18N_BIM_GUID")}:</Col>
              <Col md={3}>{t("I18N_BIM_Element_id")}:</Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="bimGuid" value={modelObjAttrs.bimGuid}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="bimElementId" value={modelObjAttrs.bimElementId}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>


        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
        />

      </Card>
    </>
  );
}

export default ModelObjAdmin_NewModelObjView;
